import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Grid,
  Button,
  CircularProgress,
  Backdrop,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  IconButton
} from '@material-ui/core';
import moment from 'moment';
import SaveIcon from '@material-ui/icons/Save';
import SearchIcon from '@material-ui/icons/Search';
import Controls from '../controls/Controls';
import { baseUrl, deductionType } from '../../utils/constants';

const getDeductionType = (e) => {
  switch (e) {
    case 'n':
      return 0;
    case 'c':
      return 1;
    case 'd':
      return 2;
    default:
      return 0;
  }
};

/* eslint-disable camelcase */
function SsbProcessLine(props) {
  const { closePopup, refId, payeeCode } = props;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [memberCode, setMemberCode] = useState('');
  const [memberSearchName, setSearchName] = useState('');
  const [list, setList] = useState([]);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  const SsbLineSchema = Yup.object().shape({
    employeeNumber: Yup.string()
      .required('EC Number is Required')
      .min(8, 'EC Number must be 8 Charecters only')
      .max(8, 'EC Number must be 8 Charecters only')
      .matches(
        /^\b([0-9]){7}([a-zA-Z]){1}\b/,
        'EC Number starts with 7 number digits and 1 Charecter at end'
      ),
    policyRefNum: Yup.string().required('Reference Number is Required'),
    // toDate: Yup.date().required('Start Date is required'),
    fromDate: Yup.date().required('End Date is required'),
    amountInCents: Yup.number()
      .typeError('you must specify a Amount in Cents')
      .min(1, 'Amount In Cents should be greater than 0')
  });

  const initialValue = {
    submissionId: refId,
    adCode: 4371, // payeeCode.substring(0, 4),
    amountInCents: 0,
    bankAccount: '',
    ded: 'DED',
    employeeNumber: '',
    fileName: '',
    fromDate: '',
    idNumber: '',
    payeeCode: Number(payeeCode),
    policyRefNum: '',
    status: 0,
    // toDate: '',
    transactionType: 0,
    // transmissionDate: '',
    deductionType: 'n',
    createDate: ''
  };

  const formik = useFormik({
    initialValues: initialValue,
    enableReinitialize: true,
    validationSchema: SsbLineSchema,
    onSubmit: (values) => {
      values.createDate = new Date();
      values.payeeCode = Number(values.payeeCode);
      console.log('SSB line details ', values);
      values.transactionType = getDeductionType(values.deductionType);
      console.log('values aaa', values);
      saveSsbDetails(values);
    }
  });

  const saveSsbDetails = (line) => {
    const jsonClient = [];
    jsonClient.push(line);
    console.log('claim line b4 save', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/ssb/saveSsbRecord`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('SSB detail save result', result);
          notifyPopup(`SSB Detail Saved Successfully!`, 'success');
          // navigate('/processes/submitssb');
          closePopup();
        },
        (error) => {
          notifyPopup(`Error in Saving SSB Line Detail!: ${error}`, 'error');
        }
      );
  };

  const getMemberInfo = async (event) => {
    if (memberCode === '') {
      notifyPopup(`No EC # Selected, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/client/GetClientByEcNumber?ecNumber=${memberCode}`).then(
      (result) => {
        console.log('member back:', result.data.result);
        if (result.data === '') {
          setLoading(false);
          notifyPopup(`Member not Found! Please enter correct EC #`, 'error');
        } else {
          formik.setFieldValue('employeeNumber', result.data.result.memberShipNo);
          formik.setFieldValue('idNumber', result.data.result.idNumber);
          setSearchName(`${result.data.result.surname} ${result.data.result.firstName}`);
          setLoading(false);
        }
      },
      (error) => {
        setLoading(false);
        notifyPopup(`Error in getMemberInfo!: ${error}`, 'error');
      }
    );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleMouseDownPassword = (event) => {
    console.log('mouse down');
    event.preventDefault();
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const defprops = {
    options: list,
    getOptionLabel: (options) =>
      `${options.tariff_desc} - $ ${options.cost} - ZiG ${options.zimcost}`
  };

  const { errors, touched, handleSubmit } = formik;

  /* eslint-disable camelcase */
  return (
    <FormikProvider value={formik}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={10}>
            <Controls.SelectJson
              name="deductionType"
              label="Deduction Type"
              options={deductionType}
            />
          </Grid>
          <Grid item xs={3} sm={4} mr={2}>
            <FormControl>
              <InputLabel htmlFor="memberCodem">Search Member</InputLabel>
              <Input
                id="memberCode"
                type="text"
                value={memberCode}
                onChange={(e) => {
                  setMemberCode(e.target.value);
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onMouseDown={handleMouseDownPassword}
                      onClick={() => getMemberInfo()}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel htmlFor="memberSearchName">Member Name</InputLabel>
              <Input id="memberSearchName" type="text" value={memberSearchName} disabled />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={10}>
            <Controls.Input name="employeeNumber" label="EC Number" disabled />
          </Grid>
          <Grid item xs={12} sm={10}>
            <Controls.Input name="idNumber" label="ID Number" disabled />
          </Grid>
          <Grid item xs={12} sm={10}>
            <Controls.DateTime name="fromDate" label="Date From" />
          </Grid>
          <Grid item xs={12} sm={10}>
            <Controls.DateTime name="toDate" label="Date To" />
          </Grid>
          <Grid item xs={12} sm={10}>
            <Controls.Input name="policyRefNum" label="Reference #" />
          </Grid>
          <Grid item xs={12} sm={10}>
            <Controls.Input name="payeeCode" label="SSB Code #" />
          </Grid>
          <Grid item xs={12} sm={10}>
            <Controls.InputNumber name="amountInCents" label="Amount In Cents" />
          </Grid>

          <Grid margin={2} container direction="row" justifyContent="right" alignItems="right">
            <Grid item xs={12} sm={1} marginRight={1}>
              <Button
                type="submit"
                variant="contained"
                startIcon={<SaveIcon />}
                disabled={formik.values.treatmentDate === '' || formik.values.tarrif_id === 0}
              >
                Save...
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Form>
    </FormikProvider>
  );
}

export default SsbProcessLine;
